import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/sympla/comprador/discovery-next/src/components/FAQAccordionCX/FAQAccordionCX.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/sympla/comprador/discovery-next/src/components/OrganizerBanner/OrganizerBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RootStoreProvider"] */ "/builds/sympla/comprador/discovery-next/src/providers/RootStoreProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/sympla/comprador/discovery-next/src/templates/Home/Content.tsx");
